import { Link } from "react-router-dom";
import { Radar } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-surface-border bg-surface-card" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-8 px-6 py-12 sm:grid-cols-3">
        <div>
          <div className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-white">
            <Radar className="h-4 w-4 text-sovereign" />
            BRAND<span className="text-sovereign">SIGNAL</span>
          </div>
          <p className="text-sm text-slate-500">
            AI reputation intelligence across OpenAI, Claude, Gemini and Perplexity.
          </p>
        </div>

        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">Legal &amp; Compliance</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="text-slate-400 hover:text-white" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy" className="text-slate-400 hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/ai-transparency" className="text-slate-400 hover:text-white" data-testid="footer-ai-transparency-link">AI Transparency Disclosure</Link></li>
          </ul>
        </div>

        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">Resources</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/handbook" className="text-slate-400 hover:text-white" data-testid="footer-handbook-link">The Intelligence Handbook</Link></li>
            <li><Link to="/support" className="text-slate-400 hover:text-white" data-testid="footer-support-link">Support &amp; Feedback</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-surface-border px-6 py-4 text-center text-xs text-slate-400">
        &copy; {new Date().getFullYear()} BrandSignal. All reports are AI-generated intelligence, not verified fact. See our AI Transparency Disclosure.
      </div>
    </footer>
  );
};
